import { useI18n } from "@/context/I18nContext";
import { LANGS } from "@/lib/translations";
import { Globe } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { saveLangToAccount } from "@/lib/theme";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function LanguageSwitcher() {
  const { lang, setLang } = useI18n();
  const { user } = useAuth();
  const current = LANGS.find((l) => l.code === lang) || LANGS[0];
  const pick = (code) => { setLang(code); if (user) saveLangToAccount(code); };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="lang-switcher" className="flex items-center gap-1.5 text-sm font-medium px-2 py-1.5 rounded-sm hover:bg-secondary transition-colors">
          <Globe size={16} /> {current.short}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {LANGS.map((l) => (
          <DropdownMenuItem key={l.code} data-testid={`lang-option-${l.code}`} onClick={() => pick(l.code)}
            className={lang === l.code ? "font-semibold text-accent" : ""}>
            {l.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
